import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()
export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'repeatCount',
      type: 'select',
      label: '重复次数',
      clearable: true,
      placeholder: '重复次数',
      options: [
        {title: '全部', value: ''},
        {title: '> 1', value: 1},
        {title: '> 2', value: 2},
        {title: '> 3', value: 3},
        {title: '> 4', value: 4},
        {title: '> 5', value: 5},
        {title: '> 6', value: 6},
        {title: '> 7', value: 7},
        {title: '> 8', value: 8},
        {title: '> 9', value: 9},
        {title: '> 10', value: 10}
      ]
    }
  ]
}
